module.exports = __webpack_public_path__ + "img/title-bg.a4cdf1b6.png";